const List = ({ handleId }) => {
  const listDataArray = [
    {
      sectionTitle: "Quick Start",
      questionList: [
        {
          id: "#30",
          question: "Where am I?",
        },
        {
          id: "#11",
          question: "How do I add my first business data?",
        },
      ],
    },
    {
      sectionTitle: "Product Support",
      questionList: [
        {
          id: "#28",
          question: "Does Proximity have a mobile app?",
        },
        {
          id: "#5",
          question: "Can I use Proximity without using the internet?",
        },
        {
          id: "#17",
          question: "Can I store photos and documents in Proximity?",
        },
      ],
    },
    {
      sectionTitle: "Settings",
      questionList: [
        {
          id: "#6",
          question: "Can I change the colour of the application?",
        },
        {
          id: "#7",
          question: "Can I rename the fields?",
        },
        {
          id: "#24",
          question: "Can I change the welcome message?",
        },
      ],
    },

    {
      sectionTitle: "Map Services",
      questionList: [
        {
          id: "#1",
          question: "Can I search for anything?",
        },
        {
          id: "#15",
          question: "Can I search only in Canada?",
        },
        {
          id: "#8",
          question:
            "What is the difference between simple and advanced search?",
        },
        {
          id: "#13",
          question: "How do I search for two places on the map?",
        },
        {
          id: "#29",
          question: "Can I change the map pin colour or icon?",
        },
        {
          id: "#3",
          question: "Can I change my map view?",
        },
        {
          id: "#10",
          question: "Can I colour code my different types of clients?",
        },
      ],
    },

    {
      sectionTitle: "Data Views",
      questionList: [
        {
          id: "#14",
          question: "Can I email someone from Proximity?",
        },
        {
          id: "#12",
          question: "Can I compare different places on the dashboard?",
        },
        {
          id: "#21",
          question: "Can I update a client's phone number?",
        },
      ],
    },

    {
      sectionTitle: "Data Management",
      questionList: [
        {
          id: "#9",
          question: "How do I add all my clients onto the map in one go?",
        },
        {
          id: "#23",
          question: "How do I export data from Proximity?",
        },
        {
          id: "#16",
          question: "Can I link my CRM or accounting software to the map?",
        },
        {
          id: "#19",
          question: "Can I search Google Maps through Proximity?",
        },
        {
          id: "#22",
          question: "How do I delete a client or location we no longer serve?",
        },
        {
          id: "#11",
          question: "How do I add a new client/place?",
        },
      ],
    },

    {
      sectionTitle: "Identity and Access Management",
      questionList: [
        {
          id: "#18",
          question: "Can I log in using my email?",
        },
        {
          id: "#25",
          question: "I can't log in",
        },
        {
          id: "#4",
          question: "Why can't I access the search results?",
        },
        {
          id: "#26",
          question: "I need to remove a user.",
        },
      ],
    },
    {
      sectionTitle: "Audit Trail",
      questionList: [
        {
          id: "#20",
          question: "Can I get an audit trail of all the changes?",
        },
      ],
    },
  ];

  return (
    <ol>
      {listDataArray.map((user, index) => (
        <div key={index} className="faq-list__topic">
          <li className="faq-list__topic-title">{user.sectionTitle}</li>
          <ul>
            {user.questionList.map((question, index) => (
              <li key={index}>
                <a
                  href={`${question.id}`}
                  onClick={(ev) => handleId(ev, question.id)}
                  id={question.id}
                  className="faq-list__link"
                >
                  {question.question}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </ol>
  );
};

export default List;
